/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Addresslabel2Inputs */

const ja_company_companydetails_addresslabel2 = /** @type {(inputs: Company_Companydetails_Addresslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`住所`)
};

const en_company_companydetails_addresslabel2 = /** @type {(inputs: Company_Companydetails_Addresslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Company_Companydetails_Addresslabel2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_addresslabel2 = /** @type {((inputs?: Company_Companydetails_Addresslabel2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Addresslabel2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_addresslabel2(inputs)
	return en_company_companydetails_addresslabel2(inputs)
});
export { company_companydetails_addresslabel2 as "company_companyDetails_addressLabel" }